import { render, staticRenderFns } from "./taskUrgent.vue?vue&type=template&id=ec677afa&scoped=true&"
import script from "./taskUrgent.vue?vue&type=script&lang=js&"
export * from "./taskUrgent.vue?vue&type=script&lang=js&"
import style0 from "./taskUrgent.vue?vue&type=style&index=0&id=ec677afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec677afa",
  null
  
)

export default component.exports